import { render, staticRenderFns } from "./curriculumView.vue?vue&type=template&id=88508d04&scoped=true"
import script from "./curriculumView.vue?vue&type=script&lang=js"
export * from "./curriculumView.vue?vue&type=script&lang=js"
import style0 from "./curriculumView.vue?vue&type=style&index=0&id=88508d04&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88508d04",
  null
  
)

export default component.exports